<template>
    <div
        v-observe-visibility="{ callback: visibilityChanged, once: true}"
        :class="cssClass"
    >
        <img
            ref="image"
            :alt="alt"
            class="kgr-image animated fadeIn"
            :class="[
                {
                    'loaded': loaded,
                    'kgr-image--circle': circle,
                },
                cssClass
            ]"
        />
    </div>
</template>

<script>
import '../../../../../web/css/animate.css';

export default {
    props: {
        src: {
            type: String,
            required: true,
            example: 'https://picsum.photos/200/200/?random'
        },
        alt: {
            type: String,
            required: false,
            example: 'Awesome image'
        },
        circle: {
            type: Boolean,
            required: false,
        },
        cssClass: {
            type: String,
            required: false,
            example: 'kgr-profileImage__image'
        },
    },
    data() {
        return {
            loaded: false,
        };
    },
    methods: {
        visibilityChanged(isVisible) {
            if (isVisible) {
                const tmpImg = new Image();

                tmpImg.src = this.src;
                if (tmpImg.complete) {
                    this.imgLoaded()
                } else {
                    tmpImg.addEventListener('load', this.imgLoaded);
                }

            }
        },
        imgLoaded() {
            if (!this.$refs?.image) {
                return;
            }
            this.$refs.image.src = this.src;
            this.$forceUpdate();
            this.loaded = true;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .kgr-image {
        display: none;

        &.loaded {
            display: block;
        }
    }
</style>
